{
  "header": "Documentos",
  "noDocuments": "No tienes ningún documento",
  "noDocumentsFiltered": "No hay documentos que coincidan con sus criterios de búsqueda",
  "errorStateTitleDocuments": "No se pueden cargar los documentos",
  "signed": "Firmado",
  "notSigned": "Sin firmar",
  "signedExternally": "Firmado externamente",
  "headerTabs": {
    "html": "HTML",
    "pdf": "PDF"
  },
  "tabs": {
    "statements": {
      "title": "Declaraciones",
      "noDocuments": "No tiene ninguna declaración",
      "noDocumentsFiltered": "No hay declaraciones que coincidan con sus criterios de búsqueda",
      "errorStateTitleDocuments": "No se pueden cargar las declaraciones"
    },
    "agreements": {
      "title": "Acuerdos",
      "noAgreements": "Actualmente no tiene ningún acuerdo firmado",
      "noAgreementsFiltered": "No hay acuerdos que coincidan con sus criterios de búsqueda",
      "errorStateTitleAgreements": "No se pueden cargar los acuerdos",
      "uploadAgreement": "Cargar {{agreementName}}"
    },
    "taxDocuments": {
      "title": "Documentos fiscales",
      "noDocuments": "No tiene ningún documento fiscal",
      "noDocumentsFiltered": "No hay documentos fiscales que coincidan con sus criterios de búsqueda",
      "errorStateTitleDocuments": "No se pueden cargar los documentos fiscales"
    },
    "uploadedDocuments": {
      "title": "Documentos cargados",
      "noDocuments": "No tiene ningún documento fiscal",
      "noDocumentsFiltered": "No hay documentos que coincidan con sus criterios de búsqueda",
      "errorStateTitleDocuments": "No se pueden cargar los documentos",
      "documentUploadedSuccessfully": "Documento cargado correctamente: {{fileName}}"
    },
    "tradeConfirmations": {
      "title": "Confirmaciones de transacciones",
      "noDocuments": "No tiene ninguna confirmación de operación",
      "noDocumentsFiltered": "No hay confirmaciones comerciales que coincidan con sus criterios de búsqueda",
      "errorStateTitleDocuments": "No se pueden cargar las confirmaciones de operaciones"
    },
    "clientReports": {
      "title": "Reportes de cliente",
      "noClientReports": "No tiene ningún informe de cliente",
      "noClientReportsFiltered": "No hay informes de clientes que coincidan con sus criterios de búsqueda",
      "errorStateTitleClientReports": "No se pueden cargar los informes del cliente"
    },
    "formCompletions": {
      "title": "Formularios"
    },
    "tableHeaders": {
      "date": "Fecha",
      "name": "Nombre",
      "frequency": "Frecuencia"
    }
  },
  "button": {
    "uploadDocuments": "Cargar documentos",
    "uploadDocumentsMobile": "Cargar",
    "uploadDocumentsEnhanced": "Agregar"
  },
  "addDocumentModal": {
    "title": "Cargar documentos",
    "subText": "Puede subir cualquiera de estos tipos de archivos: .jpg, .csv, .jpeg, .pdf o .png.",
    "selectFile": "Seleccionar un archivo",
    "inputLabel": "Nombre del documento",
    "inputPlaceholder": "Escriba el nombre de su documento",
    "shareDocumentWithEveryone": "Compartir documento con todos",
    "grantAccessDocument": "Conceder acceso al documento a",
    "grantAccessDocumentError": "Se requiere al menos un perfil profesional",
    "button": {
      "upload": "Cargar",
      "cancel": "Cancelar"
    },
    "tabs": {
      "statements": {
        "title": "Cargar declaraciones"
      },
      "taxDocuments": {
        "title": "Cargar documentos fiscales"
      },
      "uploadedDocuments": {
        "title": "Cargar documentos"
      },
      "tradeConfirmations": {
        "title": "Cargar confirmaciones de transacciones"
      }
    }
  },
  "filter": {
    "any": "Cualquiera",
    "button": {
      "applyFilters": "Aplicar",
      "resetFilters": "Restablecer todos los filtros"
    },
    "date": "Rango temporal",
    "account": "Cuentas",
    "placeholder": {
      "selectAccount": "Seleccionar una cuenta"
    },
    "dateOptions": {
      "YEAR_TO_DATE": "Año a la fecha",
      "MONTH_TO_DATE": "Mes a la fecha",
      "CUSTOM": "Personalizado"
    },
    "types": {
      "title": "Tipo",
      "accountStatements": {
        "MANAGEMENT_FEES_ANNUAL_REPORT": "Informe anual sobre comisiones de gestión",
        "ADMINISTRATIVE_FEES_ANNUAL_REPORT": "Informe anual sobre comisiones administrativas",
        "ANNUAL_PERFORMANCE_REPORT": "Informe anual de rendimiento",
        "OV_MONTHLY_ACCOUNT_STATEMENTS": "Declaraciones mensuales de la cuenta OneVest",
        "MONTHLY_ACCOUNT_STATEMENTS": "Declaraciones de cuenta mensuales",
        "ANNUAL_ACCOUNT_STATEMENTS": "Declaraciones de cuenta anuales",
        "QUARTERLY_ACCOUNT_STATEMENTS": "Declaraciones de cuenta trimestrales",
        "CONSOLIDATED_MONTHLY_ACCOUNT_STATEMENTS": "Declaraciones de cuenta mensuales consolidadas",
        "ACCOUNT_STATEMENT": "Estado de cuenta",
        "TAX_SLIPS_LAST_10_MONTHS": "Formularios fiscales de los últimos 10 meses",
        "TAX_SLIPS_FIRST_60_DAYS": "Formularios fiscales de los primeros 60 días",
        "TAX_SLIPS_T4RSP_RL2": "Formularios fiscales T4RSP RL2",
        "TAX_SLIPS_T4RIF_RL2": "Formularios fiscales T4RIF RL2",
        "TAX_SLIPS_T4A_RL1": "Formularios fiscales T4A RL1",
        "TAX_SLIPS_NR4": "Formularios fiscales NR4",
        "TAX_SLIPS_T5008": "Formularios fiscales T5008",
        "TAX_SLIPS_TRADING_SUMMARY": "Resumen de operaciones con formularios fiscales",
        "TAX_SLIPS_T5_RL3": "Formularios fiscales T5 RL3",
        "TAX_SLIPS_T3_RL16": "Formularios fiscales T3 RL16",
        "TAX_SLIPS_T3_BREAKDOWN": "Desglose de los formularios fiscales T3",
        "TAX_SLIPS_T5013_RL15": "Formularios fiscales T5013 RL15",
        "TAX_SLIP_GENERAL": "Hoja de impuestos general",
        "TAX_SLIPS_T4_FHSA": "Formularios fiscales T4 FHSA",
        "TAX_SLIPS_REST_OF_YEAR": "Comprobantes fiscales del resto del año",
        "TAX_SLIPS_RL2": "Comprobantes fiscales RL2",
        "TAX_SLIPS_T3": "Comprobantes fiscales T3",
        "TAX_SLIPS_T5": "Comprobantes fiscales T5",
        "TAX_SLIPS_T4RIF": "Comprobantes fiscales T4RIF",
        "TAX_SLIPS_T4A": "Comprobantes fiscales T4A",
        "TAX_SLIPS_T4RSP": "Comprobantes fiscales T4RSP",
        "TRADE_CONFIRMATION": "Confirmación de la operación"
      },
      "clientReports": {
        "ACCOUNT": "Cuenta",
        "GOAL": "Meta",
        "SUB_ACCOUNT": "Subcuenta",
        "CLIENT_GROUP": "Grupo de clientes",
        "INDIVIDUAL": "Individual",
        "NON_INDIVIDUAL": "No individual",
        "ACCOUNT_GROUP": "Grupo de cuentas"
      }
    },
    "taxYear": "Año fiscal",
    "taxYearError": "Ingrese un año válido de 4 dígitos entre 1900 y {{currentYear}}"
  },
  "droppableFileInput": {
    "dragFilesHere": "Arrastre y suelte un archivo aquí",
    "or": "o",
    "chooseAFile": "Examinar un archivo",
    "clickToBrowse": "Arrastre el archivo aquí o haga clic para buscarlo",
    "browse": "Explorar",
    "chooseAnotherFile": "Elija otra opción",
    "fileSize": "Tamaño del documento",
    "maxDocumentSize": "Tamaño máximo del documento: {{fileMaxSize}} MB",
    "max": "Máximo: {{fileMaxSize}} MB",
    "documentRequired": "Se requiere adjuntar un documento",
    "fileIsAboveMaxSize": "El tamaño del archivo ({{size}}) supera el máximo permitido",
    "fileIsUnsupportedType": "Tipo de archivo no compatible ({{type}}). Utilice uno de los siguientes: {{acceptedTypes}}",
    "submit": "Cargar"
  },
  "editDocumentModal": {
    "tabs": {
      "statements": {
        "title": "Editar declaración",
        "documentName": "Estado de declaración"
      },
      "taxDocuments": {
        "title": "Editar documento fiscal",
        "documentName": "Nombre del documento fiscal"
      },
      "uploadedDocuments": {
        "title": "Editar documento",
        "documentName": "Nombre del documento"
      },
      "tradeConfirmations": {
        "title": "Editar confirmación de operación",
        "documentName": "Nombre de confirmación de operación"
      }
    }
  },
  "formCompletions": {
    "table": {
      "name": "Nombre",
      "package": "Paquete",
      "signedBy": "Firmado por",
      "signedAt": "Firmado en"
    }
  },
  "downloadDocuments": {
    "downloadedSuccessfully": "Documentos descargados correctamente",
    "downloadedPartially": "Documentos descargados parcialmente: {{successCount}} de {{totalFiles}}",
    "downloadFailed": "Error al descargar documentos"
  }
}
